export const getStylesInFormat = (styles) => {
    const items = styles.map((style) => {
        let item = 'style=';
        const { elementType, featureType, stylers } = style;
        if (featureType) {
            item += `feature:${featureType}|`;
        }
        if (elementType) {
            item += `element:${elementType}|`;
        }
        item += stylers
            .map((styler) => {
            let onlyOneItem;
            for (const itemArray of Object.entries(styler)) {
                const itemProperty = itemArray[0];
                const itemValue = itemArray[1];
                onlyOneItem = `${itemProperty}:${itemValue}`;
            }
            return onlyOneItem;
        })
            .join('|');
        return item;
    });
    return items.join('&');
};
//# sourceMappingURL=utils.js.map